export default __webpack_public_path__ + "records.06f2f03.png";